import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { BehaviorSubject, Observable, of, fromEvent } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CorporateService } from 'src/app/services/corporate.service';
import { CreateCorporateComponent } from '../create-corporate/create-corporate.component';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DeleteCorporateComponent } from '../delete-corporate/delete-corporate.component';
import { UpdateBranchVerifyLevelComponent } from './update-branch-verify-level/update-branch-verify-level.component';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-list-corporates',
  templateUrl: './list-corporates.component.html',
  styleUrls: ['./list-corporates.component.css']
})
export class ListCorporatesComponent implements OnInit, AfterViewInit {
  corporateCount: any;
  tableFilters = '';
  collapsed;
  showToolBar = false;
  selectedIndex = -1;
  domainModel = 0;
  licenseModel = 0;
  @ViewChild('go', {static: false}) go: ElementRef;
  configData: any = {};
  verifyLevels: any = [];

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
    // tslint:disable-next-line: no-use-before-declare
    dataSource =  new CorporatetblDataSource(this.corporateService);
    // tslint:disable-next-line: max-line-length
    // displayedColumns = ['id', 'uid', 'name', 'code', 'multilevel', 'centralised', 'officePhone', 'officeEmail', 'verifiedLevel', 'branchJdnStatus'];
    // displayedColumns = ['id', 'uid', 'name', 'code', 'multilevel', 'contactPhone', 'contactName', 'verifiedLevel'];
    displayedColumns = ['id', 'uid', 'created_date' , 'name', 'code', 'multilevel', 'centralised', 'contactPhone', 'contactName', 'verifiedLevel'];
  corporate: any;
  serviceSectors: any = [];
  subDomains: any = [];
  domain: any;
  licensePkgs: any = [];
  jdnStatus: any = [];
  screenHeight;
  screenWidth;
  small_device_display = false;
  constructor(private corporateService: CorporateService, private dialog: MatDialog,
    private commonFilter: CommonfilterService, private router: Router, private activatedRoute: ActivatedRoute) { 
      this.onResize();
    }

  ngOnInit() {

    this.commonFilter.getConfigData()
    .subscribe(res => {
      this.configData = res;
     this.jdnStatus=this.configData.jdnStatus;
      this.verifyLevels = this.configData.verifyLevel;
    });
    this.commonFilter.getServiceSectors()
    .subscribe(res => {
      this.serviceSectors = res;
    });
    this.commonFilter.getLicensePackages()
      .subscribe(res => {
        this.licensePkgs = res;
      });
    this.dataSource.loadCorporates(this.tableFilters, 'false', 0, 100);

    this.getTotalCountByFilters(this.tableFilters);
  }

  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    console.log(this.screenWidth);
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      console.log(projectConstants.SMALL_DEVICE_BOUNDARY);
      console.log(this.screenWidth);
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  getTotalCountByFilters(filter) {
    this.corporateService.getTotalFilterCount(filter)
    .subscribe( data => this.corporateCount = data);
   }
   onCorporateClicked(corporate) {
     this.selectedIndex = corporate.corporateId;
     this.showToolBar = true;
     this.corporate = corporate;
   }
   createCorporate() {
    const dialogreference = this.dialog.open(CreateCorporateComponent, {
      width: '800px',
      data: {'type': 'add'}
    });
    dialogreference.afterClosed().subscribe(result => {
      this.loadCorporatePage();
    });
   }
   deleteCorporate() {
     const dialogreference = this.dialog.open(DeleteCorporateComponent, {
       width: '800px',
       data: this.selectedIndex

     });
     dialogreference.afterClosed().subscribe(result => {
     this.loadCorporatePage();
     });

   }
   showLicenseDetails() {
    this.router.navigate(['../licensedetails'],  { queryParams: this.corporate , relativeTo: this.activatedRoute});
   }
   updateBranchVerifyLevel() {
    const dialogreference = this.dialog.open(UpdateBranchVerifyLevelComponent, {
      data: this.selectedIndex

    });
    dialogreference.afterClosed().subscribe(result => {
    this.loadCorporatePage();
    });
   }
   updateCorporate() {
    const dialogreference = this.dialog.open(CreateCorporateComponent, {
      width: '800px',
      data: {'type': 'edit', 'corporate': this.corporate}
    });
    dialogreference.afterClosed().subscribe(result => {
      this.loadCorporatePage();
    });
   }
   setJDN() {
    this.router.navigate(['../jdn'], { queryParams: this.corporate, relativeTo: this.activatedRoute });
   }
   uploadCSV() {
    this.router.navigate(['../uploadcsv'], { relativeTo: this.activatedRoute });
   }
   viewBranches() {
    this.router.navigate(['../branches'],  { queryParams: this.corporate, relativeTo: this.activatedRoute} );
   }
   uploadBranchLogo() {
     this.router.navigate(['../uploadlogo'], { relativeTo: this.activatedRoute});
   }
   onDomainChange(event) {
    this.subDomains = [];
    for (let i = 0; i < this.serviceSectors.length; i++) {
      // tslint:disable-next-line:triple-equals
      if (event.target.value == this.serviceSectors[i].id) {
        this.domain = this.serviceSectors[i].domain;
        for (let j = 0; j < this.serviceSectors[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.serviceSectors[i].subDomains[j].displayName,
            'id': this.serviceSectors[i].subDomains[j].id, 'subDomain': this.serviceSectors[i].subDomains[j].subDomain
          });
        }
      }
    }
  }
  ngAfterViewInit() {
    this.paginator.page
    .pipe(
        tap(() => this.loadCorporatePage())
    )
    .subscribe();

    fromEvent(this.go.nativeElement, 'click')
    .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
            this.tableFilters = this.commonFilter.createfilterParams('corporate');
            this.getTotalCountByFilters(this.tableFilters);
            this.paginator.pageIndex = 0;
            this.loadCorporatePage();
        })
    )
    .subscribe();
}
loadCorporatePage() {
  const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
  this.dataSource.loadCorporates(
    this.tableFilters,
    'false',
    count,
    this.paginator.pageSize);
    console.log(this.dataSource.loadCorporates);
}
updateJaldeeVerify() {
  this.router.navigate(['../jaldeeVerification/update',  {'type': 'corporate', 'id' : this.corporate.corporateId}],
  { relativeTo: this.activatedRoute });
}
}
export class CorporatetblDataSource implements DataSource<any> {

  private corporateSubject = new BehaviorSubject<any>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private corporateService: CorporateService) {

  }
  connect(collectionViewer: CollectionViewer): Observable<any> {
     return this.corporateSubject.asObservable();

  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.corporateSubject.complete();
    this.loadingSubject.complete();
  }

  loadCorporates( filter,
  sortDirection, count, pageSize) {

  this.loadingSubject.next(true);

  this.corporateService.getCorporates( filter, sortDirection,
    count, pageSize).pipe(
     catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
    .subscribe(corporates => this.corporateSubject.next(corporates));
  }
}
